import _ from 'underscore';
import PolicyChange from 'edge/endorsement/common/models/PolicyChange';

export default (function (q, EndorsementService, AvailabilityService, TranslateService, ViewModelService) {

    var translateFn = TranslateService.instant;

    var createViewModel = function createViewModel(model) {
        return ViewModelService.create(new PolicyChange(model), 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
    };

    var ACTIONS = {
        save: function save(model) {
            return EndorsementService.saveEndorsement(model.value).then(createViewModel);
        },
        generateQuote: function generateQuote(model) {
            return EndorsementService.isQuoted(model.jobID.value).then(function (isQuoted) {
                return isQuoted ? q.resolve(model) : EndorsementService.quoteEndorsement(model.jobID.value).then(createViewModel);
            });
        }
    };

    var ACTION_MSG = {
        save: {
            error: {
                title: 'gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Unable to save',
                message: 'gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.An error occurred while attempting to save.'
            }
        },
        generateQuote: {
            error: {
                title: 'gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Unable to quote',
                message: 'gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.An error occurred while attempting to quote.'
            }
        }
    };

    return function (step) {

        step('pcBopPolicyDetails', true).skipOnResumeIf(function () {
            return true;
        }).onNext.doAction(ACTIONS.save, ACTION_MSG.save).thenGoTo('pcBopGeneralCoverages', 'transactionError').label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Policy Details');
        });

        step('pcBopGeneralCoverages').onNext.goTo('pcBopAdditionalCoverages').skipOnResumeIf(function (_ref) {
            var model = _ref.value;

            var coverages = model.lobData.businessOwners.coverages.lobCoverages;
            return model.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
        }).label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.General Coverages');
        });

        step('pcBopAdditionalCoverages').onNext.goTo('pcBopLocationsAndBuildings').skipOnResumeIf(function (_ref2) {
            var model = _ref2.value;

            var coverages = model.lobData.businessOwners.coverages.additionalCoverages;
            return model.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
        }).label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Additional Coverages');
        });

        step('pcBopLocationsAndBuildings').skipOnResumeIf(function (_ref3) {
            var model = _ref3.value;
            return model.status === 'Quoted';
        }).onNext.doAction(ACTIONS.generateQuote, ACTION_MSG.generateQuote).thenGoTo('pcBopQuote', 'transactionError').label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Locations and Buildings');
        });

        step('pcBopQuote').onNext.branch(function (model) {
            var increasePremium = model.transactionCost.amount && model.transactionCost.amount.value > 0;
            return increasePremium ? 'pcBopPaymentDetails' : 'confirmation';
        }, function () {
            return 'transactionError';
        }).label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Quote');
        });

        step('pcBopPaymentDetails').onNext.goTo('confirmation').label(function () {
            return translateFn('gw-portals-policytransaction-pc-bop-angular.config.FlowConfig.Payment Details');
        });
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=BusinessOwners!./common/js/src/edge/gw-portals-policytransaction-pc-bop-angular/config/FlowConfig.js
// module id = 433
// module chunks = 0